var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 6.4c-1.2.5-2.4.9-3.8 1 1.4-.8 2.4-2 2.9-3.5-1.3.7-2.7 1.3-4.2 1.5a6.8 6.8 0 00-4.8-2c-3.6 0-6.6 2.9-6.6 6.4 0 .5.1 1 .2 1.5-5.4-.4-10.2-2.9-13.5-6.8-.6.9-.9 2-.9 3.2 0 2.2 1.2 4.2 2.9 5.3-1.1 0-2.1-.3-3-.8v.1c0 3.1 2.3 5.7 5.3 6.3-.6.1-1.1.2-1.7.2-.4 0-.8 0-1.2-.1.8 2.5 3.3 4.4 6.1 4.4-2.2 1.7-5.1 2.7-8.2 2.7-.5 0-1.1 0-1.6-.1 2.9 1.8 6.4 2.9 10.1 2.9 12.1 0 18.7-9.7 18.7-18.2v-.8c1.3-.8 2.4-2 3.3-3.2z",
    className: "st0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.f678cad7.svg";
export { ForwardRef as ReactComponent };